import { render, staticRenderFns } from "./AlertingSlack.vue?vue&type=template&id=317613fa&scoped=true"
import script from "./AlertingSlack.vue?vue&type=script&lang=js"
export * from "./AlertingSlack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317613fa",
  null
  
)

export default component.exports